import { DestroyRef, inject, PLATFORM_ID } from '@angular/core';
import { shareAsReplaySubject } from '@core/shared/utils';
import { BehaviorSubject, combineLatest, fromEvent, of } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { matchMedia$, takeWhileAlive } from '@core/frontend-shared';
import * as i0 from "@angular/core";
export var ScreenDimension = /*#__PURE__*/function (ScreenDimension) {
  ScreenDimension["Mobile"] = "Mobile";
  ScreenDimension["Tablet"] = "Tablet";
  ScreenDimension["Desktop"] = "Desktop";
  ScreenDimension["LargeDesktop"] = "LargeDesktop";
  return ScreenDimension;
}(ScreenDimension || {});
// const ScreenDimensionRank = {
// 	[ScreenDimension.Mobile]: 1,
// 	[ScreenDimension.Tablet]: 2,
// 	[ScreenDimension.Desktop]: 3,
// 	[ScreenDimension.LargeDesktop]: 4,
// }
export let ScreenService = /*#__PURE__*/(() => {
  class ScreenService {
    constructor(config) {
      this.config = config;
      this.destroyRef = inject(DestroyRef);
      this.platformId = inject(PLATFORM_ID);
      this._windowWidth$ = new BehaviorSubject(960);
      this.windowWidth$ = this._windowWidth$.asObservable();
      this.config$ = new BehaviorSubject(null);
      this.currentSize$ = combineLatest({
        config: this.config$,
        width: this.windowWidth$
      }).pipe(map(({
        width,
        config
      }) => {
        if (!config) return ScreenDimension.Tablet;
        if (width >= config.breakpointLargeDesktop) return ScreenDimension.LargeDesktop;else if (width >= config.breakpointTablet) return ScreenDimension.Desktop;else if (width >= config.breakpointMobile) return ScreenDimension.Tablet;else return ScreenDimension.Mobile;
      }));
      this.isMobile$ = this.currentSize$.pipe(map(size => size === ScreenDimension.Mobile));
      this.isTablet$ = this.currentSize$.pipe(map(size => size === ScreenDimension.Tablet));
      this.isMobileOrTablet$ = this.currentSize$.pipe(map(size => size === ScreenDimension.Mobile || size === ScreenDimension.Tablet));
      this.isDesktop$ = this.currentSize$.pipe(map(size => size === ScreenDimension.LargeDesktop || size === ScreenDimension.Desktop));
      this.isLargeDesktop$ = this.currentSize$.pipe(map(size => size === ScreenDimension.LargeDesktop));
      this.isLandscape$ = isPlatformBrowser(this.platformId) ? matchMedia$('(orientation: landscape)').pipe(shareAsReplaySubject(1)) : of(true);
      this.config$.next(config);
      if (isPlatformBrowser(this.platformId)) {
        const resizeWindowWidth$ = fromEvent(window, 'resize').pipe(debounceTime(50), map(e => e.target['innerWidth']), startWith(window.innerWidth), shareAsReplaySubject(1), takeWhileAlive(this.destroyRef));
        resizeWindowWidth$.subscribe(width => {
          this._windowWidth$.next(width);
        });
      }
    }
    static {
      this.ɵfac = function ScreenService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScreenService)(i0.ɵɵinject('SCREEN_SERVICE_CONFIG_PROVIDER'));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ScreenService,
        factory: ScreenService.ɵfac
      });
    }
  }
  return ScreenService;
})();